(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stores"] && !window.DesignMode) return;
  try {
    

var tglBtns = document.getElementsByClassName("store_name");
var addressAnchors = document.getElementsByClassName("addressAnchor");
let store_info = document.getElementsByClassName("store_info");

function resetStatus() {
  for (let i = 0; i < tglBtns.length; i++) {
    const button = tglBtns[i];
    // Unactivate buttons
    button.classList.remove('active');

    // Close open menus
    let store_info = button.nextElementSibling;
    store_info.style.maxHeight = null;
  }
}

for (let i = 0; i < tglBtns.length; i++) {
  tglBtns[i].addEventListener("click", function() {
    if (!this.classList.contains("active")) {
      // unactivate active buttons and close open menus
      resetStatus();

      // Activate pressed button
      this.classList.toggle("active");

      // Open selected store info
      store_info = this.nextElementSibling;
      if (store_info.style.maxHeight){
        store_info.style.maxHeight = null;
      } else {
        store_info.style.maxHeight = store_info.scrollHeight + "px";
        // store_info.style.maxHeight = "100%";
      }
      // Find and switch image
      let index   = this.getAttribute("data-store-index");
      let images  = document.getElementsByClassName("storeImage");
      for (let i = 0; i < images.length; i++) {
        let image = images[i];
        if (image.getAttribute("data-image-index") == index) {
          image.setAttribute("data-hidden", "false")
        } else {
          image.setAttribute("data-hidden", "true")
        }
      }
    }
  })
}

for (let i = 0; i < addressAnchors.length; i++) {
  const anchor = addressAnchors[i];
  anchor.addEventListener("click", function(e){
    e.preventDefault();
    if (/Android|webOS|Windows Phone|Windows/.test(navigator.userAgent)) {
      window.open('https://maps.google.com/maps?q=' + encodeURIComponent(anchor.innerText));
    } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      window.open('https://maps.apple.com/?q=' + encodeURIComponent(anchor.innerText));
    } else {
      window.open('https://maps.google.com/maps?q=' + encodeURIComponent(anchor.innerText));
    }
  })
}


  } catch(e) { console.error(e); }
})();
})();
